<script lang="ts" setup>
const { categories } = defineProps<{
  categories: Array<{ name: string, icon: string, id: string }>;
}>();

</script>

<template>
  <div class="category-list">
    <div v-for="category in categories.slice(0, 7)" :key="category.id" class="map-category">
      <i :class="`${category.icon}`" />
      {{ category.name }}
    </div>
    <div v-if="categories.length > 4" style="color: var(--color-slate-400);margin-top:0.35rem;font-size:0.8rem;">
      + {{ categories.length - 4 }} More
    </div>
  </div>
</template>

<style scoped>
.category-list {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  overflow: hidden;
  max-width: fit-container;
  padding: 0;
  max-width: 90vw;
  overflow-x: scroll;
  scrollbar-width: none;
  &::-webkit-scrollbar {
      display: none;  /* Safari and Chrome */
  }
  .map-category {
    color: var(--color-slate-700);
    white-space: nowrap;
    i {
      color: var(--color-slate-400);
      font-size: 1.2rem;
      padding-right: 0.1rem;
    }
  }
}
</style>
